const workoutTranslations = {
  Intro: {
    intro: "إنها حقيقة مثبتة منذ زمن طويل أن القارئ سوف يصرف انتباهه",
    title: "رحلتك تبدأ هنا.",
    description: `المكان الوحيد الذي يأتي فيه النجاح قبل العمل
        موجود في القاموس. العرق هو مجرد بكاء الدهون. استمر فى دفع
        حدودك حتى يبهر جسدك روحك`,
    calendar: "تقويم التمرين",
  },
  workoutPlanner: {
    day: "يوم",
    action: "إعادة ضبط التقويم",
  },
  restDay: {
    description: "اليوم هو يوم راحة لذا تأكد من التعافي جيدًا لتعود أقوى.",
    rest: "إنه يوم راحتك.",
  },
  workoutStepper: {
    warmUp: "الاحماء",
    exercises: "التمارين",
    cardio: "كارديو",
    postWorkoutStretches: "التمدد بعد التدريب",
    nextButton: "التالي",
    finishButton: "انهاء",
    backButton: "السابق",
  },
  cardioNoticePopUp: {
    title: "تنبيه",
    description: "برجاء اختيار تمرين واحد فقد للكارديو من التمارين المعروضة,",
    actionButton: "اغلاق",
  },
};

export default workoutTranslations;
